// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"fc681fbd","977":"b1ad6698"}[chunkId] + ".chunk.js";
};